export const arr = [
    { name: "first", desc: "first img desc", imgSrc: "https://www.bookswagon.com/bannerimages/86_inr.jpg?v=2.5" },
    { name: "second", desc: "second img desc", imgSrc: "https://www.bookswagon.com/bannerimages/88_inr.jpg" },
    { name: "third", desc: "third img desc", imgSrc: "https://www.bookswagon.com/bannerimages/80_inr.jpg?v=2.1" },
    { name: "fourth", desc: "fourth img desc", imgSrc: "https://www.bookswagon.com/bannerimages/79_inr.jpg?v=2.5" },
    { name: "fifth", desc: "fifth img desc", imgSrc: "https://bc-img.s3.ap-south-1.amazonaws.com/web_banners/2023090261162.webp" }
]